export default [
  { path: '/callcenter', component: () => import('./Main.vue'), name: 'callcenter.main' }
]
